(function () {
  if (window.CAFReviewDisplayCountsInitialized) {
    return;
  }

  window.CAFReviewDisplayCountsInitialized = true;

  var hasManualFilterOrSort = false;
  var hasInitializedDefaultSort = false;

  function toLower(value) {
    return String(value || '')
      .toLowerCase()
      .trim();
  }

  function toInteger(value) {
    var digits = String(value || '').replace(/[^\d]/g, '');
    return digits ? parseInt(digits, 10) : 0;
  }

  function toFloat(value) {
    var normalized = String(value || '')
      .replace(',', '.')
      .replace(/[^\d.]/g, '');
    var parsed = parseFloat(normalized);

    return Number.isFinite(parsed) ? parsed : 0;
  }

  function formatNumber(value) {
    return String(Math.max(0, Math.round(Number(value || 0)))).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // The store rating keeps two decimals (4.97), like the badges and Judge.me's own summary: one decimal rounds it up to 5.0.
  function formatRating(value) {
    var rating = Math.min(5, Math.max(0, toFloat(value)));

    return rating ? rating.toFixed(2) : '';
  }

  function setTextContent(element, text) {
    if (element && element.textContent !== text) {
      element.textContent = text;
    }
  }

  function setAttribute(element, attributeName, value) {
    if (element && element.getAttribute(attributeName) !== value) {
      element.setAttribute(attributeName, value);
    }
  }

  function getStoredInteger(element, attributeName) {
    var value = element ? element.getAttribute(attributeName) : null;

    if (value === null || value === '') {
      return null;
    }

    return toInteger(value);
  }

  // Judge.me's own totals, as it prints them: nothing is added (owner decision 2026-10-12, DECISIONS "Real review numbers").
  function getDisplayReviewCounts(realProductCount, realShopCount, realTotalCount) {
    var realProduct = toInteger(realProductCount);
    var realShop = toInteger(realShopCount);
    var realTotal = toInteger(realTotalCount);

    return {
      product: realProduct,
      shop: realShop,
      total: realTotal || realProduct + realShop,
    };
  }

  function getAllReviewsRoot(root) {
    var context = root || document;

    return context.querySelector(
      '.jdgm-all-reviews-widget-v2025, #judgeme_all_reviews_page, .jdgm-all-reviews-page, .jdgm-all-reviews-widget',
    );
  }

  function getReviewCarouselRoots(root) {
    var context = root || document;
    var selectors = ['[data-caf-review-carousel]', '.jdgm-carousel-wrapper'];
    var roots = [];
    var seen = new Set();
    var i;
    var j;
    var found;
    var node;

    for (i = 0; i < selectors.length; i += 1) {
      found = context.querySelectorAll(selectors[i]);
      for (j = 0; j < found.length; j += 1) {
        node = found[j];
        if (seen.has(node)) {
          continue;
        }
        seen.add(node);
        roots.push(node);
      }
    }

    return roots;
  }

  function updateAllReviewsDisplayedCounts(root) {
    var widgetRoot = getAllReviewsRoot(root);
    var header;
    var productTab;
    var shopTab;
    var productCountNode;
    var shopCountNode;
    var summaryText;
    var storedProductCount;
    var storedShopCount;
    var storedTotalCount;
    var realProductCount;
    var realShopCount;
    var realTotalCount;
    var displayCounts;
    var displayProductCount;
    var displayShopCount;
    var displayTotalCount;

    if (!widgetRoot) {
      return;
    }

    header = widgetRoot.querySelector('.jdgm-all-reviews__header');
    productTab = widgetRoot.querySelector('.jdgm-subtab__name[data-tabname="product-reviews"]');
    shopTab = widgetRoot.querySelector('.jdgm-subtab__name[data-tabname="shop-reviews"]');
    productCountNode = productTab ? productTab.querySelector('.jdgm-subtab__count') : null;
    shopCountNode = shopTab ? shopTab.querySelector('.jdgm-subtab__count') : null;
    summaryText = widgetRoot.querySelector('.jdgm-all-reviews__summary-text');
    storedProductCount = getStoredInteger(widgetRoot, 'data-caf-real-product-reviews');
    if (storedProductCount === null) {
      storedProductCount = getStoredInteger(header, 'data-caf-real-product-reviews');
    }
    storedShopCount = getStoredInteger(widgetRoot, 'data-caf-real-shop-reviews');
    if (storedShopCount === null) {
      storedShopCount = getStoredInteger(header, 'data-caf-real-shop-reviews');
    }
    storedTotalCount = getStoredInteger(widgetRoot, 'data-caf-real-total-reviews');
    if (storedTotalCount === null) {
      storedTotalCount = getStoredInteger(header, 'data-caf-real-total-reviews');
    }

    realProductCount =
      storedProductCount !== null
        ? storedProductCount
        : toInteger(header && header.getAttribute('data-number-of-product-reviews')) ||
          toInteger(productCountNode && productCountNode.textContent);
    realShopCount =
      storedShopCount !== null
        ? storedShopCount
        : toInteger(header && header.getAttribute('data-number-of-shop-reviews')) ||
          toInteger(shopCountNode && shopCountNode.textContent);

    realTotalCount =
      storedTotalCount !== null ? storedTotalCount : toInteger(header && header.getAttribute('data-number-of-reviews'));
    displayCounts = getDisplayReviewCounts(realProductCount, realShopCount, realTotalCount);
    displayProductCount = displayCounts.product;
    displayShopCount = displayCounts.shop;
    displayTotalCount = displayCounts.total;

    if (productCountNode) {
      setTextContent(productCountNode, formatNumber(displayProductCount));
    }

    if (shopCountNode) {
      setTextContent(shopCountNode, formatNumber(displayShopCount));
    }

    if (summaryText) {
      setTextContent(summaryText, 'Based on ' + formatNumber(displayTotalCount) + ' reviews');
    }

    if (header) {
      setAttribute(header, 'data-caf-real-product-reviews', String(realProductCount));
      setAttribute(header, 'data-caf-real-shop-reviews', String(realShopCount));
      setAttribute(header, 'data-caf-real-total-reviews', String(realTotalCount));
      setAttribute(header, 'data-number-of-product-reviews', String(displayProductCount));
      setAttribute(header, 'data-number-of-shop-reviews', String(displayShopCount));
      setAttribute(header, 'data-number-of-reviews', String(displayTotalCount));
    }

    setAttribute(widgetRoot, 'data-caf-real-product-reviews', String(realProductCount));
    setAttribute(widgetRoot, 'data-caf-real-shop-reviews', String(realShopCount));
    setAttribute(widgetRoot, 'data-caf-real-total-reviews', String(realTotalCount));
    widgetRoot.dataset.cafDisplayProductReviews = String(displayProductCount);
    widgetRoot.dataset.cafDisplayShopReviews = String(displayShopCount);
    widgetRoot.dataset.cafDisplayTotalReviews = String(displayTotalCount);
  }

  function renderCountLabel(template, count) {
    var formatted = formatNumber(count);
    if (template && template.indexOf('__CAF_COUNT__') !== -1) {
      return template.split('__CAF_COUNT__').join(formatted);
    }
    return 'from ' + formatted + ' reviews';
  }

  function updateReviewCarouselDisplayedCounts(root) {
    var roots = getReviewCarouselRoots(root);
    var i;
    var carouselRoot;
    var countNode;
    var ratingNode;
    var ratingWrapper;
    var ratingValueNode;
    var realRating;
    var displayRating;
    var realTotalCount;
    var displayCounts;
    var countTemplate;

    for (i = 0; i < roots.length; i += 1) {
      carouselRoot = roots[i];
      countNode = carouselRoot.querySelector('[data-caf-review-count], .jdgm-carousel-number-of-reviews');
      ratingNode = carouselRoot.querySelector('.jdgm-all-reviews-rating');
      ratingWrapper = carouselRoot.querySelector('.jdgm-all-reviews-rating-wrapper');
      ratingValueNode = carouselRoot.querySelector('[data-caf-review-rating-value]');
      countTemplate = carouselRoot.getAttribute('data-caf-review-count-template') || '';

      realTotalCount =
        toInteger(carouselRoot.getAttribute('data-caf-real-review-count')) ||
        toInteger(countNode && countNode.getAttribute('data-caf-real-review-count'));
      realRating =
        toFloat(ratingValueNode && ratingValueNode.getAttribute('data-caf-real-review-rating')) ||
        toFloat(ratingNode && ratingNode.getAttribute('data-score')) ||
        toFloat(ratingNode && ratingNode.getAttribute('aria-label'));

      if (!realTotalCount && countNode) {
        realTotalCount =
          toInteger(countNode.getAttribute('data-number-of-reviews')) || toInteger(countNode.textContent);
      }

      if (!realTotalCount) {
        continue;
      }

      setAttribute(carouselRoot, 'data-caf-real-review-count', String(realTotalCount));
      displayCounts = getDisplayReviewCounts(0, 0, realTotalCount);
      carouselRoot.dataset.cafDisplayTotalReviews = String(displayCounts.total);
      displayRating = formatRating(realRating);

      if (ratingWrapper) {
        setAttribute(ratingWrapper, 'data-caf-display-total-reviews', String(displayCounts.total));
      }

      if (ratingValueNode && displayRating) {
        setTextContent(ratingValueNode, displayRating);
      }

      if (countNode) {
        setAttribute(countNode, 'data-caf-real-review-count', String(realTotalCount));
        setAttribute(countNode, 'data-number-of-reviews', String(displayCounts.total));
        setTextContent(countNode, renderCountLabel(countTemplate, displayCounts.total));
      }
    }
  }

  function enforceReviewCarouselItemLimit(root) {
    var roots = getReviewCarouselRoots(root);
    var i;
    var j;
    var carouselRoot;
    var limit;
    var items;
    var item;
    var shouldHide;

    for (i = 0; i < roots.length; i += 1) {
      carouselRoot = roots[i];
      limit = toInteger(carouselRoot.getAttribute('data-caf-review-card-limit'));
      items = carouselRoot.querySelectorAll('.jdgm-carousel-item');

      if (!items.length) {
        continue;
      }

      for (j = 0; j < items.length; j += 1) {
        item = items[j];
        shouldHide = limit > 0 && j >= limit;

        if (item.hidden !== shouldHide) {
          item.hidden = shouldHide;
        }

        if (shouldHide) {
          setAttribute(item, 'aria-hidden', 'true');
        } else if (item.getAttribute('aria-hidden') === 'true') {
          item.removeAttribute('aria-hidden');
        }
      }
    }
  }

  function hydrateReviewCarouselImages(root) {
    var context = root || document;
    var images = context.querySelectorAll('.jdgm-carousel-item__product-image[data-src]');
    var i;
    var image;
    var src;
    var retinaSrc;

    for (i = 0; i < images.length; i += 1) {
      image = images[i];
      if (!image || image.getAttribute('src') || image.closest('.jdgm-carousel-item[hidden]')) {
        continue;
      }

      src = image.getAttribute('data-src');
      retinaSrc = image.getAttribute('data-src-retina');

      if (!src) {
        continue;
      }

      setAttribute(image, 'src', src);
      setAttribute(image, 'loading', 'lazy');
      setAttribute(image, 'decoding', 'async');

      if (retinaSrc) {
        setAttribute(image, 'srcset', src + ' 1x, ' + retinaSrc + ' 2x');
      }
    }
  }

  function getCarouselScrollStep(container) {
    var wrapper = container && container.querySelector('.jdgm-carousel__item-wrapper');
    var item = container && container.querySelector('.jdgm-carousel-item');
    var gap = 0;
    var styles;

    if (!container || !item) {
      return container ? Math.max(240, container.clientWidth * 0.9) : 0;
    }

    if (wrapper && window.getComputedStyle) {
      styles = window.getComputedStyle(wrapper);
      gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    }

    return item.getBoundingClientRect().width + gap;
  }

  function scrollReviewCarousel(container, direction) {
    var step = getCarouselScrollStep(container);

    if (!container || !step) {
      return;
    }

    container.scrollBy({
      left: direction * step,
      behavior: 'smooth',
    });
  }

  function clampScrollLeft(container, scrollLeft) {
    var maxScrollLeft = container ? container.scrollWidth - container.clientWidth : 0;

    return Math.max(0, Math.min(maxScrollLeft, scrollLeft));
  }

  function snapReviewCarouselToNearest(container, velocityX) {
    var step = getCarouselScrollStep(container);
    var target;
    var ratio;

    if (!container || !step) {
      return;
    }

    ratio = container.scrollLeft / step;

    if (Math.abs(velocityX) > 0.35) {
      target = velocityX < 0 ? Math.ceil(ratio) * step : Math.floor(ratio) * step;
    } else {
      target = Math.round(ratio) * step;
    }

    container.scrollTo({
      left: clampScrollLeft(container, target),
      behavior: 'smooth',
    });
  }

  function enhanceReviewCarouselInteractions(root) {
    var roots = getReviewCarouselRoots(root);
    var i;
    var carouselRoot;
    var container;
    var leftArrow;
    var rightArrow;

    function bindArrow(arrow, activeContainer, direction) {
      if (!arrow || arrow.dataset.cafArrowScrollInitialized) {
        return;
      }

      arrow.dataset.cafArrowScrollInitialized = 'true';
      arrow.setAttribute('role', 'button');
      arrow.setAttribute('aria-label', direction < 0 ? 'Previous reviews' : 'Next reviews');

      arrow.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
          }
          scrollReviewCarousel(activeContainer, direction);
        },
        true,
      );

      arrow.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        event.preventDefault();
        scrollReviewCarousel(activeContainer, direction);
      });
    }

    function bindDrag(activeContainer) {
      var isPointerDown = false;
      var hasDragged = false;
      var startX = 0;
      var startScrollLeft = 0;
      var activePointerId = null;
      var lastX = 0;
      var lastTime = 0;
      var pendingScrollLeft = 0;
      var rafId = 0;
      var velocityX = 0;

      if (!activeContainer || activeContainer.dataset.cafDragScrollInitialized) {
        return;
      }

      activeContainer.dataset.cafDragScrollInitialized = 'true';
      activeContainer.querySelectorAll('a, img').forEach(function (element) {
        setAttribute(element, 'draggable', 'false');
      });

      function flushDragScroll() {
        activeContainer.scrollLeft = clampScrollLeft(activeContainer, pendingScrollLeft);
        rafId = 0;
      }

      function queueDragScroll(scrollLeft) {
        pendingScrollLeft = scrollLeft;

        if (!rafId) {
          rafId = window.requestAnimationFrame(flushDragScroll);
        }
      }

      activeContainer.addEventListener('pointerdown', function (event) {
        if (event.button !== 0 || event.pointerType === 'touch') {
          return;
        }

        isPointerDown = true;
        hasDragged = false;
        startX = event.clientX;
        startScrollLeft = activeContainer.scrollLeft;
        activePointerId = event.pointerId;
        lastX = event.clientX;
        lastTime = performance.now();
        pendingScrollLeft = startScrollLeft;
        velocityX = 0;
        activeContainer.classList.add('is-caf-dragging');

        if (activeContainer.setPointerCapture) {
          try {
            activeContainer.setPointerCapture(activePointerId);
          } catch (error) {
            // Synthetic preview checks do not create an active pointer, but real pointer events still can capture normally.
          }
        }
      });

      activeContainer.addEventListener('pointermove', function (event) {
        var deltaX;
        var now;
        var elapsed;

        if (!isPointerDown) {
          return;
        }

        deltaX = event.clientX - startX;
        now = performance.now();
        elapsed = now - lastTime;

        if (elapsed > 0) {
          velocityX = (event.clientX - lastX) / elapsed;
          lastX = event.clientX;
          lastTime = now;
        }

        if (Math.abs(deltaX) > 3) {
          hasDragged = true;
          event.preventDefault();
          queueDragScroll(startScrollLeft - deltaX);
        }
      });

      function endDrag() {
        if (rafId) {
          window.cancelAnimationFrame(rafId);
          flushDragScroll();
        }

        isPointerDown = false;
        activePointerId = null;
        activeContainer.classList.remove('is-caf-dragging');

        if (hasDragged) {
          snapReviewCarouselToNearest(activeContainer, velocityX);
        }
      }

      activeContainer.addEventListener('pointerup', endDrag);
      activeContainer.addEventListener('pointercancel', endDrag);
      activeContainer.addEventListener('pointerleave', function () {
        if (isPointerDown) {
          endDrag();
        }
      });

      activeContainer.addEventListener(
        'click',
        function (event) {
          if (!hasDragged) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          hasDragged = false;
        },
        true,
      );
    }

    for (i = 0; i < roots.length; i += 1) {
      carouselRoot = roots[i];
      container = carouselRoot.querySelector('.jdgm-carousel__item-container');
      leftArrow = carouselRoot.querySelector('.jdgm-carousel__left-arrow');
      rightArrow = carouselRoot.querySelector('.jdgm-carousel__right-arrow');

      bindDrag(container);
      bindArrow(leftArrow, container, -1);
      bindArrow(rightArrow, container, 1);
    }
  }

  function updateReviewDisplayData(root) {
    updateAllReviewsDisplayedCounts(root);
    updateReviewCarouselDisplayedCounts(root);
    enforceReviewCarouselItemLimit(root);
    hydrateReviewCarouselImages(root);
    enhanceReviewCarouselInteractions(root);
  }

  function isRecentValue(value) {
    var v = toLower(value);
    return (
      v.indexOf('most_recent') !== -1 ||
      v.indexOf('most-recent') !== -1 ||
      v.indexOf('most recent') !== -1 ||
      v === 'recent' ||
      v === 'newest'
    );
  }

  function isRecentText(value) {
    var v = toLower(value);
    return v.indexOf('most recent') !== -1 || v.indexOf('newest') !== -1 || v.indexOf('latest') !== -1;
  }

  function isPicturesFirstValue(value) {
    var v = toLower(value);
    return (
      v.indexOf('pictures_first') !== -1 ||
      v.indexOf('pictures-first') !== -1 ||
      v.indexOf('pictures first') !== -1 ||
      v.indexOf('photos_first') !== -1 ||
      v.indexOf('photos-first') !== -1 ||
      v.indexOf('photos first') !== -1
    );
  }

  function isPicturesFirstText(value) {
    var v = toLower(value);
    return (
      v.indexOf('pictures first') !== -1 ||
      v.indexOf('photos first') !== -1 ||
      v.indexOf('picture first') !== -1 ||
      v.indexOf('photo first') !== -1
    );
  }

  function getPictureFirstOption(select) {
    if (!select || !select.options || !select.options.length) {
      return null;
    }

    var i;
    var option;

    for (i = 0; i < select.options.length; i += 1) {
      option = select.options[i];
      if (isPicturesFirstValue(option.value)) {
        return option;
      }
    }

    for (i = 0; i < select.options.length; i += 1) {
      option = select.options[i];
      if (isPicturesFirstText(option.text)) {
        return option;
      }
    }

    return null;
  }

  function getMostRecentOption(select) {
    if (!select || !select.options || !select.options.length) {
      return null;
    }

    var i;
    var option;

    for (i = 0; i < select.options.length; i += 1) {
      option = select.options[i];
      if (isRecentValue(option.value)) {
        return option;
      }
    }

    for (i = 0; i < select.options.length; i += 1) {
      option = select.options[i];
      if (isRecentText(option.text)) {
        return option;
      }
    }

    return null;
  }

  function getSortSelects(root) {
    var context = root || document;
    var selectors = [
      'select.jdgm-sort-dropdown',
      '.jdgm-sort-dropdown select',
      '.jdgm-rev-widg select',
      '#judgeme_all_reviews_page select',
      '.jdgm-all-reviews-page select',
    ];
    var list = [];
    var seen = new Set();
    var i;
    var j;
    var found;
    var el;

    for (i = 0; i < selectors.length; i += 1) {
      found = context.querySelectorAll(selectors[i]);
      for (j = 0; j < found.length; j += 1) {
        el = found[j];
        if (!el || el.tagName !== 'SELECT') {
          continue;
        }
        if (seen.has(el)) {
          continue;
        }
        seen.add(el);
        list.push(el);
      }
    }

    return list;
  }

  function isSortControl(element) {
    if (!element || element.tagName !== 'SELECT') {
      return false;
    }

    return element.matches(
      'select.jdgm-sort-dropdown, .jdgm-sort-dropdown select, .jdgm-rev-widg select, #judgeme_all_reviews_page select, .jdgm-all-reviews-page select',
    );
  }

  function applyDefaultSort(root) {
    if (hasManualFilterOrSort || hasInitializedDefaultSort) {
      return false;
    }

    var selects = getSortSelects(root);
    var i;
    var select;
    var option;
    var foundEligibleSelect = false;

    for (i = 0; i < selects.length; i += 1) {
      select = selects[i];
      option = getPictureFirstOption(select) || getMostRecentOption(select);

      if (!option) {
        continue;
      }

      foundEligibleSelect = true;

      if (toLower(select.value) === toLower(option.value)) {
        hasInitializedDefaultSort = true;
        return true;
      }

      select.value = option.value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
      hasInitializedDefaultSort = true;
      return true;
    }

    return foundEligibleSelect;
  }

  function hasJudgeMeWidget() {
    return Boolean(
      document.querySelector(
        '.jdgm-rev-widg, #judgeme_all_reviews_page, .jdgm-all-reviews-page, .jdgm-widget:not(.jdgm-preview-badge), .jdgm-carousel-wrapper, [data-caf-review-carousel]',
      ),
    );
  }

  function isReviewMutationTarget(node) {
    var element = node && node.nodeType === 1 ? node : node && node.parentElement;

    return Boolean(
      element &&
        element.closest &&
        element.closest(
          '.jdgm-widget, .jdgm-rev-widg, #judgeme_all_reviews_page, .jdgm-all-reviews-page, .jdgm-carousel-wrapper, [data-caf-review-carousel]',
        ),
    );
  }

  function initAutoSort() {
    if (!hasJudgeMeWidget()) {
      return;
    }

    var attempts = 0;
    var maxAttempts = 30;
    var displayAttempts = 0;
    var maxDisplayAttempts = 20;

    applyDefaultSort(document);
    updateReviewDisplayData(document);

    var timer = window.setInterval(function () {
      attempts += 1;
      applyDefaultSort(document);

      if (hasManualFilterOrSort || hasInitializedDefaultSort || attempts >= maxAttempts) {
        window.clearInterval(timer);
      }
    }, 500);

    var displayTimer = window.setInterval(function () {
      displayAttempts += 1;
      updateReviewDisplayData(document);

      if (displayAttempts >= maxDisplayAttempts) {
        window.clearInterval(displayTimer);
      }
    }, 500);

    var observer = new MutationObserver(function (mutations) {
      if (hasManualFilterOrSort) {
        return;
      }

      var i;
      var j;
      var node;
      var shouldUpdateDisplay = false;

      for (i = 0; i < mutations.length; i += 1) {
        if (mutations[i].type === 'characterData' || isReviewMutationTarget(mutations[i].target)) {
          shouldUpdateDisplay = true;
        }

        for (j = 0; j < mutations[i].addedNodes.length; j += 1) {
          node = mutations[i].addedNodes[j];
          if (!node) {
            continue;
          }

          if (isReviewMutationTarget(node)) {
            shouldUpdateDisplay = true;
          }

          if (node.nodeType !== 1) {
            continue;
          }

          if (
            node.matches &&
            node.matches('.jdgm-widget, .jdgm-rev-widg, .jdgm-carousel-wrapper, [data-caf-review-carousel], .jdgm-sort-dropdown, select')
          ) {
            if (!hasInitializedDefaultSort) {
              applyDefaultSort(document);
            }
            updateReviewDisplayData(document);
            return;
          }
          if (
            node.querySelector &&
            node.querySelector('.jdgm-widget, .jdgm-rev-widg, .jdgm-carousel-wrapper, [data-caf-review-carousel], .jdgm-sort-dropdown, select')
          ) {
            if (!hasInitializedDefaultSort) {
              applyDefaultSort(node);
            }
            updateReviewDisplayData(node);
            return;
          }
        }
      }

      if (shouldUpdateDisplay) {
        updateReviewDisplayData(document);
      }
    });

    observer.observe(document.documentElement, { characterData: true, childList: true, subtree: true });
    updateReviewDisplayData(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoSort);
  } else {
    initAutoSort();
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!event.isTrusted || !target) {
        return;
      }

      if (
        isSortControl(target) ||
        (target.closest && target.closest('.jdgm-rev-widg__header, #judgeme_all_reviews_page'))
      ) {
        hasManualFilterOrSort = true;
      }
    },
    true,
  );

  document.addEventListener('shopify:section:load', function () {
    applyDefaultSort(document);
    updateReviewDisplayData(document);
  });
  document.addEventListener('jdgm:loaded', function () {
    applyDefaultSort(document);
    updateReviewDisplayData(document);
  });
  document.addEventListener('judgeme:loaded', function () {
    applyDefaultSort(document);
    updateReviewDisplayData(document);
  });

  window.CAFReviewDisplayCounts = {
    formatNumber: formatNumber,
    formatRating: formatRating,
    getDisplayReviewCounts: getDisplayReviewCounts,
    update: updateReviewDisplayData,
  };
})();
